import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CallService } from '../../../../../src/app/shared/services';
// External
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { forEach } from 'lodash';
// Helpers internal
import { AutoSubs, AutoUnsubscribe, Logger } from '../../../../../src/app/shared/misc';
// Interfaces
import { MenuStructureSplit } from '../interfaces';
// Services
import { UiParamsService } from '../services/ui-params.service';

@AutoUnsubscribe()
@Component({
	selector    : 'menu-navigation',
	templateUrl : './navigation.component.html',
	styleUrls   : ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, AfterViewInit, OnDestroy {
	@AutoSubs() subs;
	@ViewChild('header_holder') private header_holder : ElementRef<HTMLElement>;
	@ViewChild('header_element', { read: ElementRef }) private header_element : ElementRef<HTMLElement>;

	public splitStructure : MenuStructureSplit = {
		header : [],
		main   : [],
		search : null
	};
	public render_sidebar : boolean = false;
	private resize$ = new Subject<{}>();
	private header : HTMLElement;
	private header_resize_observer : ResizeObserver;

	constructor(private call : CallService,
	            private uiParams : UiParamsService
	)
	{

		/*We have menu loaded*/
		document.querySelector('html').classList.add('menuLoaded');

		const response = JSON.parse(window['ngMenu']);

		// Sort to correct menu
		forEach(response.items, item => {
			if (item.header) {
				this.splitStructure.header = [...this.splitStructure.header, item];
			} else {
				this.splitStructure.main = [...this.splitStructure.main, item];
			}
		});

		this.render_sidebar = !!this.splitStructure.main.length;
		// We now have menu structure, check if sidebar should be leaked
		this.resize$.next({});
	}

	ngAfterViewInit(): void
	{
		// Measured, not a constant: the fixed bar's row count varies with the setup name and the
		// customer's web links.
		this.header = this.header_element.nativeElement.querySelector('header');
		if (!this.header) return;

		this.header_resize_observer = new ResizeObserver(() => this.syncHeaderHolderHeight());
		this.header_resize_observer.observe(this.header);
	}

	ngOnDestroy(): void
	{
		this.header_resize_observer?.disconnect();
	}

	private syncHeaderHolderHeight() : void
	{
		// `important` to outrank the narrow-width `!important` holder height in nexus_app.scss.
		this.header_holder.nativeElement.style.setProperty(
			'height',
			`${ this.header.getBoundingClientRect().height }px`,
			'important'
		);
	}

	@HostListener('window:resize', [])
	onResize()
	{
		this.resize$.next({});
	}

	ngOnInit(): void
	{
		this.subs = this.resize$.pipe(debounceTime(300)).subscribe(() => this.handleResize());
		// Set first time, then wait for resize event
		this.resize$.next({});
	}

	handleResize()
	{
		// Synced with _menu-shared-variables.scss $breakpoint-mobile
		this.uiParams.is_mobile_view = window.matchMedia('(max-width: 603px)').matches; // No support for IE9 and below
	}
}
